import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

/**
 * Main API instance (keeps /api/* calls untouched)
 */
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Upload API (no /api prefix)
 */
export const uploadApi = axios.create({
  baseURL: API_BASE,
});

export const setupInterceptors = (dispatch: any, navigate: any) => {
  const attachToken = (config: any) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  };

  api.interceptors.request.use(attachToken);
  uploadApi.interceptors.request.use(attachToken);

  const onError = async (error: any) => {
    if (error.response?.status === 401) {
      await dispatch({ type: 'auth/logoutRdx' });
      navigate('/login');
    } else if (error.response && error.response.status !== 400) {
      navigate('/error');
    }
    return Promise.reject(error);
  };

  api.interceptors.response.use((r) => r, onError);
  uploadApi.interceptors.response.use((r) => r, onError);
};

export default api;
